<template>
  <div>
    <TitleFrame text="ホーム">
      <template slot="contents">
        <div class="content-area">
          <p class="list-title">ピックアップイベント</p>
          <hooper
            class="img-list"
            :infiniteScroll="true"
            :itemsToShow="2.75"
            :centerMode="true"
            :autoPlay="true"
            :playSpeed="3000"
            v-if="eventdata.length !== 0 && currentPageName === 'Home'"
          >
            <slide
              v-for="(item, index) in eventdata"
              :key="index"
              class="img-list-item"
            >
              <img
                :src="item.images[0].image_url"
                @click="
                  onClickNewsItem({
                    text_content: item.text_content,
                    html_content: item.html_content,
                    images: item.images,
                  })
                "
              />
            </slide>
          </hooper>
          <p class="list-title">開催中のイベント</p>
          <ul class="list">
            <li
              v-for="(item, index) in eventdata"
              :key="index"
              @click="onClickNewsItem(item)"
            >
              <img :src="item.images[0].image_url" />
              <div class="title-area">
                <p class="title">
                  {{ item.title }}
                </p>
                <p class="description">
                  {{ item.text_content }}
                </p>
                <p class="date">
                  {{ formatDate(item.opened_at) }} ～
                  {{ formatDate(item.closed_at) }}
                </p>
              </div>
              <img class="chev" src="@/assets/chevron.svg" />
            </li>
          </ul>
          <div class="rank-area">
            <div class="rank-item">
              <p class="text">
                {{ registrationData.Point }}
              </p>
              <p class="unit">ポイント</p>
            </div>
            <div class="rank-item">
              <p class="text">{{ registrationData.Rank }}</p>
              <p class="unit">ランク</p>
            </div>
          </div>
        </div>
        <div v-if="isDialogOpen" class="background" @click="onClose"></div>
        <div v-if="isDialogOpen" class="dialog">
          <img
            v-for="(item, index) in selectedNewsItem.images"
            :key="index"
            :src="item.image_url"
          />
          <p class="date">
            {{ formatDate(selectedNewsItem.opened_at) }} ～
            {{ formatDate(selectedNewsItem.closed_at) }}
          </p>
          <p class="title">
            {{ selectedNewsItem.title }}
          </p>
          <p class="description" v-html="selectedNewsItem.text_content" />
          <ButtonTextLink
            v-if="selectedNewsItem.html_content"
            class="syosai-button"
            text="詳細を見る"
            :isRed="true"
            @click-text="onClickShosaiButton(selectedNewsItem.html_content)"
          />
          <ButtonTextLink
            class="close-button"
            text="閉じる"
            @click-text="onClose"
          />
        </div>
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleFrame from "@/components/Templates/TitleFrame";
import axios from "axios";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";

export default {
  name: "home",
  components: {
    TitleFrame,
    ButtonTextLink,
    Hooper,
    Slide,
  },
  computed: {
    ...mapState(["email", "registrationData", "currentPageName"]),
  },
  data() {
    return {
      selectedNewsItem: undefined,
      eventdata: [],
      isDialogOpen: false,
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onClickNewsItem(val) {
      this.selectedNewsItem = val;
      this.isDialogOpen = true;
    },
    onClose() {
      this.selectedNewsItem = undefined;
      this.isDialogOpen = false;
    },
    onClickShosaiButton(val) {
      window.open(val, "_blank");
    },
  },
  watch: {
    currentLat: {
      immideate: true,
      handler: function () {
        if (this.currentLng) {
          this.lat = this.currentLat;
          this.lng = this.currentLng;
        }
      },
    },
    currentLng: {
      immideate: true,
      handler: function () {
        if (this.currentLat) {
          this.lat = this.currentLat;
          this.lng = this.currentLng;
        }
      },
    },
  },
  async mounted() {
    this.loadingStartMini();
    await axios
      .get(
        "https://mission-kqxgrnovcq-uc.a.run.app/api/events?api_key=i73rauGTyfewa&registration_id=emqiPRkCnYQ6E7ma1Zwr",
      )
      .then((response) => {
        this.eventdata = response.data;
      });
    this.loadingEndMini();
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.text {
  text-align: center;
  margin: 4px 0;
}

.rank-area {
  margin: 0 1.25rem;
  display: flex;
  justify-content: space-between;
  border-radius: 20px;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 2px 4px 0px rgba(1, 39, 76, 0.14);
  padding: 16px 0;
  bottom: 7vh;
  position: fixed;
  width: calc(100% - 3rem);
  .rank-item {
    width: 100%;
    text-align: center;
    p {
      margin: 0;
    }
    .text {
      color: #242529;
      font-weight: bold;
      margin-bottom: 0.25rem;
    }
    .unit {
      color: #848a94;
      font-size: 0.75rem;
    }
    &:not(:last-child) {
      border-right: 1px solid #e0e0e0;
    }
  }
}

.modal {
  background-color: white;
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
}
.list-title {
  text-align: left;
  margin: 1rem 1.25rem 0.25rem;
  font-size: 0.8rem;
  font-weight: 700;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0 1.25rem 1rem;
  height: calc(100% - 30vh);

  overflow: scroll;
  img {
    width: 80px;
    margin-right: 1rem;
  }

  li {
    display: flex;
    padding: 1rem 0rem;
    border-bottom: 1px #e7e7e7 solid;
    position: relative;
    justify-content: space-between;
    align-items: center;
    .title-area {
      flex-shrink: 0;
      width: calc(100% - 80px - 2rem);
    }
    .title {
      margin: 0;
      font-size: 0.9rem;
      margin-right: 2rem;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
    .description {
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      font-size: 0.6rem;
      margin: 0.5rem 0;
      margin-right: 2rem;
      color: #bbb;
    }
    .date {
      color: #bbb;
      font-size: 0.6rem;
      line-height: 0.75rem;
      height: auto;
      margin: 0.5rem 0;
    }
    p {
      margin: 0.5rem 0;
      width: calc(100% - 1.5rem);
    }

    .chev {
      transform: rotate(-90deg);
      height: 0.5rem;
    }
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: calc(100% - 2rem * 2);
  max-height: 80%;
  overflow: scroll;
  padding: 1rem;
  border-radius: 12px;

  .date {
    color: #bbb;
    font-size: 0.8rem;
    line-height: 0.75rem;
    height: auto;
    margin: 0.5rem 0;
  }
  .title {
    font-size: 1rem;
    margin: 0.5rem 0;
  }
  .description {
    white-space: pre-wrap;
    margin: 0.5rem 0;
  }
}

.close {
  margin: 0;

  .close-button {
    margin: 0.5rem 0 0;
  }
}

.img-list {
  height: 4.5rem;
  .img-list-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30vw;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>

<style lang="scss">
.dialog {
  a,
  a:visited,
  a:hover,
  a:active {
    color: #5cd5d6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Home.vue